export default __webpack_public_path__ + "static/media/shark1.2073e7c0.jpg";